export const ACTIVE = ['queued', 'collecting', 'labeling'];

/**
 * Run status as a person reads it. Product language, not pipeline language:
 * "collecting" and "labeling" are our words for it, not the customer's.
 * Shared so the history list and the run page cannot disagree about what a
 * status is called.
 */
export const STATUS_LABEL = {
	queued: 'Queued',
	collecting: 'Listening',
	labeling: 'Reading',
	ready: 'Ready',
	partial: 'Partial',
	failed: 'Failed',
};

/** runs are newest-first. */
export function derivePageState({ accountId, runs }) {
	if (!accountId) return 'no-account';
	if (!runs || runs.length === 0) return 'empty';
	const latest = runs[0];
	if (ACTIVE.includes(latest.status)) return 'listening';
	return latest.status; // ready | partial | failed
}
